import startCase from 'lodash/startCase';
import {
  RECEIVE,
  PAGE,
  VIEW,
  CHANGE,
  CLICK,
  SELECT,
  CLOSE,
  SUBMIT,
  DISPLAY,
  TRACK,
  UPDATE,
  MEASURE,
  BOUNCE,
  TRY,
  VERIFY,
  CREATE,
  SAVE,
  CONFIRM,
  CANCEL,
  DISMISS,
  ENTER,
  LOAD,
  VALIDATE,
  SENT,
  RESENT,
  ADD,
  REMOVE,
  OPEN,
  PURCHASE,
  DECLINE,
  ENROLL,
  UPLOAD,
  ENGAGE,
} from '../constants';
import { selector } from '../utils';
import { analytics } from '../analytics';
import { errors } from '../errors';

const TYPE_VERB_MAP = {
  [RECEIVE]: 'Received',
  [PAGE]: 'Viewed',
  [VIEW]: 'Viewed',
  [CHANGE]: 'Changed',
  [CLICK]: 'Clicked',
  [SELECT]: 'Selected',
  [CLOSE]: 'Closed',
  [SUBMIT]: 'Submitted',
  [DISPLAY]: 'Displayed',
  [TRACK]: 'Tracked',
  [UPDATE]: 'Updated',
  [MEASURE]: 'Measured',
  [BOUNCE]: 'Bounced',
  [TRY]: 'Tried',
  [VERIFY]: 'Verified',
  [CREATE]: 'Created',
  [SAVE]: 'Saved',
  [CONFIRM]: 'Confirmed',
  [CANCEL]: 'Canceled',
  [DISMISS]: 'Dismissed',
  [ENTER]: 'Entered',
  [LOAD]: 'Loaded',
  [VALIDATE]: 'Validated',
  [SENT]: 'Sent',
  [RESENT]: 'Resent',
  [ADD]: 'Added',
  [REMOVE]: 'Removed',
  [OPEN]: 'Opened',
  [PURCHASE]: 'Purchased',
  [DECLINE]: 'Declined',
  [ENROLL]: 'Enrolled',
  [UPLOAD]: 'Uploaded',
};

function stripKeys(isLegacy) {
  return (input) => {
    if (isLegacy) {
      const { ...legacyEvent } = input;
      return {
        ...legacyEvent,
      };
    }
    return input;
  };
}

// eslint-disable-next-line no-underscore-dangle
export function _segmentTrack({ track, page, onError }) {
  // eslint-disable-next-line consistent-return
  return () => (event) => {
    if (
      [
        RECEIVE,
        PAGE,
        VIEW,
        CHANGE,
        CLICK,
        SELECT,
        CLOSE,
        SUBMIT,
        DISPLAY,
        TRACK,
        UPDATE,
        MEASURE,
        BOUNCE,
        TRY,
        VERIFY,
        CREATE,
        SAVE,
        CONFIRM,
        CANCEL,
        DISMISS,
        ENTER,
        LOAD,
        VALIDATE,
        SENT,
        RESENT,
        ADD,
        REMOVE,
        OPEN,
        PURCHASE,
        DECLINE,
        ENROLL,
        UPLOAD,
        ENGAGE,
      ].includes(event.verb) &&
      analytics
    ) {
      if (event.verb === PAGE) {
        return Promise.race([
          new Promise((resolve) =>
            page(
              event.segmentEventName
                ? event.segmentEventName
                : startCase(
                    [event.domain, event.object].join(' ').toLowerCase()
                  ),
              stripKeys(event.legacyEvent)({
                ...event.details,
                // moveId is here for backwards compatibility with Segment reasons.
                moveId: selector(event, 'user.move.id'),
              }),
              resolve
            )
          ),
          new Promise((_, reject) => setTimeout(() => reject(), 1000)),
        ]).catch(onError);
      }
      return Promise.race([
        new Promise((resolve) =>
          track(
            event.segmentEventName
              ? event.segmentEventName
              : startCase(
                  [TYPE_VERB_MAP[event.verb], event.domain, event.object]
                    .join(' ')
                    .toLowerCase()
                ),
            stripKeys(event.legacyEvent)({
              ...event.details,
              // moveId is here for backwards compatibility with Segment reasons.
              moveId: selector(event, 'user.move.id'),
            }),
            resolve
          )
        ),
        new Promise((_, reject) => setTimeout(() => reject(), 1000)),
      ]).catch(onError);
    }
  };
}

export const segmentTrack = _segmentTrack({
  track: analytics.track,
  page: analytics.page,
  onError: (err) => errors.captureMessage(err, { level: 'info' }),
});
